/**
 * Custom-piece CSS for chessground. chessground generates DOM elements like
 *   <piece class="pawn white">
 * inside `.cg-wrap`. We override the background-image to point at our 12
 * CircleChess SVGs. Pieces are theme-independent (don't change between
 * green-white / blue-white / default), so this CSS is loaded once at startup.
 *
 * SVGs are pulled from the existing `chessboard-package` so we don't duplicate
 * assets. When the package is removed (post-migration), copy the 12 SVGs into
 * this folder and switch the imports.
 */
import wP from 'chessboard-package/assets/ChessPieces/White-Pawn.svg';
import wR from 'chessboard-package/assets/ChessPieces/White-Rook.svg';
import wN from 'chessboard-package/assets/ChessPieces/White-Knight.svg';
import wB from 'chessboard-package/assets/ChessPieces/White-Bishop.svg';
import wQ from 'chessboard-package/assets/ChessPieces/White-Queen.svg';
import wK from 'chessboard-package/assets/ChessPieces/White-King.svg';
import bP from 'chessboard-package/assets/ChessPieces/Black-Pawn.svg';
import bR from 'chessboard-package/assets/ChessPieces/Black-Rook.svg';
import bN from 'chessboard-package/assets/ChessPieces/Black-Knight.svg';
import bB from 'chessboard-package/assets/ChessPieces/Black-Bishop.svg';
import bQ from 'chessboard-package/assets/ChessPieces/Black-Queen.svg';
import bK from 'chessboard-package/assets/ChessPieces/Black-King.svg';

/** Promotion dialog reads these by piece code (wQ, wR, wB, wN, bQ, ...). */
export const PIECE_IMAGES: Record<string, string> = {
  wP, wR, wN, wB, wQ, wK,
  bP, bR, bN, bB, bQ, bK,
};

/**
 * One CSS rule per (role, color) pair. chessground v9's class names are
 * lowercase role + color: e.g. `piece.pawn.white`.
 */
export const PIECE_CSS = `
.cg-wrap piece.pawn.white   { background-image: url('${wP}'); }
.cg-wrap piece.rook.white   { background-image: url('${wR}'); }
.cg-wrap piece.knight.white { background-image: url('${wN}'); }
.cg-wrap piece.bishop.white { background-image: url('${wB}'); }
.cg-wrap piece.queen.white  { background-image: url('${wQ}'); }
.cg-wrap piece.king.white   { background-image: url('${wK}'); }
.cg-wrap piece.pawn.black   { background-image: url('${bP}'); }
.cg-wrap piece.rook.black   { background-image: url('${bR}'); }
.cg-wrap piece.knight.black { background-image: url('${bN}'); }
.cg-wrap piece.bishop.black { background-image: url('${bB}'); }
.cg-wrap piece.queen.black  { background-image: url('${bQ}'); }
.cg-wrap piece.king.black   { background-image: url('${bK}'); }
`;
